export default {
  setCurrentTab(state, key) {
    state.currentTab = key
  },
  setCurrentSubTab(state, key) {
    state.currentSubTab = key
  },
  setAuthStateChecked(state, val) {
    state.authStateChecked = val
  },
  setUserId(state, val) {
    state.userId = val
  },
  setCustomJs(state, payload) {
    if (payload.scoped) {
      if (state.scopedCustomJs === payload.code) return
      state.scopedCustomJs = payload.code
    } else {
      if (state.globalCustomJs === payload.code) return
      state.globalCustomJs = payload.code
    }
  },
  setDashboardLoadingStatus(state, val) {
    state.dashboardNotRendered = val
  },
  setWorkspaceModels(state, val) {
    state.fbWorkspaceModels = val
  },
  setSettings(state, val) {
    state.settings = val
  },
  toggleChartComponentsSettingsShown(state, payload) {
    const settingsShown = Object.assign({}, state.chartComponentsSettingsShown)

    if (payload.val) {
      settingsShown[payload.chartId] = true
    } else {
      delete settingsShown[payload.chartId]
    }

    state.chartComponentsSettingsShown = settingsShown
  },
  clearChartComponentsSettingsShown(state) {
    state.chartComponentsSettingsShown = {}
  },
  setComputedProps(state, val) {
    state.computedProps = val
  },
  setUserList(state, users) {
    state.userList = users
  },
  setUserListAll(state, users) {
    state.userListAll = users
  },
  setPivotGridOptions(state, options) {
    state.pivotGridOptions = options
  },
  setCustomComponents(state, val) {
    state.customComponents = val
  },
  setWorkflows(state, workflow) {
    state.workflows[workflow.id] = {
      data: workflow.data,
      name: workflow.name,
    }
  },
  setWorkflowItemState(state, payload) {
    state.workflows[payload.id].data.nodes[payload.index].state = payload.state
  },
  setFiles(state, files) {
    state.files = files
  },
  setCurrentTemplate(state, template) {
    state.currentTemplate = template
  },
}
